import ContactDataService from "@/services/ContactDataService";

async function checkContactEmailRepeat(data){
    return await ContactDataService.checkContactEmailRepeat(data)
    .then(res => {
        return res.data
    })
}

export default checkContactEmailRepeat;